import React from 'react'
import ReactDOM from 'react-dom/client'

import './i18n'
import './index.css'
import App from './App.jsx'

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)

// Registered after the page is up, so it never competes with the first paint. A failure here is
// not worth a message: the app works without it, only the icon on the home screen does not.
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => {})
  })
}
